import React, { useEffect, useState } from "react";
import ReusableButton from "./ReusableButton";
import { Skeleton } from "@mui/material";
import "./TheStudentDashboard.css";
import CreditCoin from './imageFiles/CreditCoin.png';
import { history } from "../../../../../../helper/history";
import { routes } from "../../../../../../helper/routes";

const CreditsUsage = ({ userCredits = { total_credits: 0, used_credits: 0, available_credits: 0 }, student_dashboard_initial_loading }) => {

  const handleBuyCredit = async () => {
    history.push(routes.assess_subscriptions)
  }

  const total = userCredits?.total_credits || 0;
  const used = userCredits?.used_credits || 0;
  const available = userCredits?.available_credits || 0;

  const totalPercentage = total > 0 ? 100 : 0;
  const usedPercentage = total > 0 ? (used / total) * 100 : 0;
  const availablePercentage = total > 0 ? (available / total) * 100 : 0;

  return (
    <div className="credits-usage-box">
      <div className="credits-header">
        <h6 className="credits-title">Credits</h6>
      </div>
      <div className="credits-chart-content">
        {student_dashboard_initial_loading ? (
          <div className="credits-loading">
            <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: '8px', marginBottom: '8px' }} />
            <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: '8px', marginBottom: '8px' }} />
            <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: '8px' }} />
          </div>
        ) : (
          <>
            {userCredits?.total_credits <= 0 ? (
              <>
                <div className="credits-single-bar">

                  <div className="credit-bar-labels">
                    <div className="credit-label-item">
                      <span className="credit-label-text">Used: 0</span>
                    </div>
                    <div className="credit-label-item">
                      <span className="credit-label-text">Available: 0</span>
                    </div>
                  </div>

                  <div className="credit-single-bar-wrapper empty-bar">
                    <div className="credit-bar-segment used-segment" style={{ width: `0%`, backgroundColor: '#FFB657F' }}></div>
                    <div className="credit-bar-segment available-segment" style={{ width: `0%`, backgroundColor: '#FFEFDD' }}></div>
                  </div>

                  <div className="credit-total-text no-credits-text">
                    <span>No credits available. Buy more!</span>
                  </div>
                </div>

                <div className="credit-buy-row">
                  <div className="buy-more-text">
                    <img src={CreditCoin} alt="coin" className="buy-more-icon" />
                    <span>Buy Credits</span>
                  </div>
                  <div className="credit-buy-actions">
                    <div className="buy-credits-button-wrapper">
                      <ReusableButton label="Buy Credits" onClick={() => handleBuyCredit()} />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="credits-single-bar">

                  <div className="credit-bar-labels">
                    <div className="credit-label-item">
                      <span className="credit-label-text">Used: {used}</span>
                    </div>
                    <div className="credit-label-item">
                      <span className="credit-label-text">Available: {available}</span>
                    </div>
                  </div>
                  <div className="credit-single-bar-wrapper">
                    <div className="credit-bar-segment used-segment" style={{ width: `${usedPercentage}%`, backgroundColor: '#F5B24F' }}></div>
                    <div className="credit-bar-segment available-segment" style={{ width: `${availablePercentage}%`, backgroundColor: '#ffe2be' }}></div>
                  </div>
                  <div className="credit-total-text">
                    <span>Total: {total}</span>
                  </div>
                </div>

                {/* <div className="credit-divider" /> */}

                <div className="credit-buy-row">
                  <div className="buy-more-text">
                    <img src={CreditCoin} alt="coin" className="buy-more-icon" />
                    <span>Buy Credits</span>
                  </div>
                  <div className="credit-buy-actions">
                    <div className="buy-credits-button-wrapper">
                      <ReusableButton label="Buy Credits" onClick={() => handleBuyCredit()} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CreditsUsage;
